import { PRODUCTION_PURCHASE_TRANSACTION_REQUEST, GET_PRODUCTION_PURCHASE_TRANSACTIONS, GET_PRODUCTION_PURCHASE_TRANSACTIONS_TAKA_NO, PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE,
  GET_PRODUCTION_PURCHASE_TRANSACTIONS_BY_BEAM, SET_SELECTED_BEAM
 } from '../types';

const initialState = {
  transactions: [],
  transByBeam: [],
  takaNos: [],
  selectedBeam: null,
  loading: false,
  error: null,
};

const productionPurchaseTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTION_PURCHASE_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PRODUCTION_PURCHASE_TRANSACTIONS: {
      return {
        ...state,
        transactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PRODUCTION_PURCHASE_TRANSACTIONS_TAKA_NO: {
      return {
        ...state,
        takaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PRODUCTION_PURCHASE_TRANSACTIONS_BY_BEAM: {
      return {
        ...state,
        transByBeam: [...action.payload],
        loading: false,
        error: null
      }
    }
    case PRODUCTION_PURCHASE_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default productionPurchaseTransactionReducer;
